import { ThemeColor } from '@/theme/usePixydocsTheme'
import { useTheme } from '@mui/material'
import useLocalStorage from './useLocalStorage'
import { useCallback } from 'react'

export default function useGetThemeColor(): (colorName?: ThemeColor) => string {
  const theme = useTheme()
  const [themeMode] = useLocalStorage('pixydocs-theme-mode', 'dark')

  return useCallback(
    (colorName?: ThemeColor) => {
      const themeColor = theme.palette[colorName || '']
      if (!themeColor) return theme.palette.text.secondary
      return themeColor[themeMode === 'dark' ? 'dark' : 'light']
    },
    [theme, themeMode],
  )
}
